import axios from 'axios';

class ServiceNextProjectController {
  async listProjects() {
    const response = await axios.get('/api/next-project/projects');
    return response.data;
  }

  async importProjects(ids: number[]) {
    const response = await axios.post('/api/next-project/import', { ids });
    return response.data;
  }
}

export const ServiceNextProject = new ServiceNextProjectController();